module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/71451233518e248c48c49aab303d6c00.png";